import { MenuItem } from '@mui/material'
import { useAutentiqueModalStore } from 'modules/orders/components'
import { ActionsItemProps } from './actions'
import BorderColorIcon from '@mui/icons-material/BorderColor'

export const AutentiqueLink = ({ order, disabled }: ActionsItemProps) => {
  const setIsOpenModal = useAutentiqueModalStore.useSetModalOpen()
  const setProposalId = useAutentiqueModalStore.useSetProposalId()

  const handleClick = () => {
    setIsOpenModal(true)
    setProposalId(order.proposalId)
  }

  return (
    <MenuItem onClick={handleClick} disabled={disabled}>
      <BorderColorIcon />
      Autentique
    </MenuItem>
  )
}
